module.exports = __webpack_public_path__ + "static/simic-hybrid-1-b088af057567c3327c39a9ff342bba42.webp";